(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('DashboardManagementDialogController', DashboardManagementDialogController);

    DashboardManagementDialogController.$inject = ['$timeout', '$scope', '$state','entity', 'Dashboard', 'Licences'];

    function DashboardManagementDialogController ($timeout, $scope,$state, entity, Dashboard, Licences) {
        var vm = this;
        vm.dashboard = entity;
        vm.licences = Licences.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:dashboardUpdate', result);
            vm.isSaving = false;
            $state.go('dashboard-management');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.dashboard.id !== null) {
                Dashboard.update(vm.dashboard, onSaveSuccess, onSaveError);
            } else {
                Dashboard.save(vm.dashboard, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $state.go('dashboard-management');
        };
    }
})();
